// import request from '@/util/request';
// import qs from 'qs';

// export const getDeviceList = (params, options) =>
// request.get('/debug/api/device/query/devices', Object.assign({}, options, { params }));

import axios from 'axios';

import userService from "./UserService"
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
const myselfAxios = axios.create();
//默认超时时间
myselfAxios.defaults.timeout = 10000;
//返回其他状态码
myselfAxios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
//跨域请求，允许保存cookie
myselfAxios.defaults.withCredentials = true;
// NProgress 配置
NProgress.configure({
  showSpinner: false
});
//http request拦截
myselfAxios.interceptors.request.use(
  config => {
    if (userService.getToken() != null && config.url !== "/api/user/login") {
      config.headers['access-token'] = `${userService.getToken()}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
//http response 拦截
myselfAxios.interceptors.response.use((response) => {
  // 对响应数据做点什么
  let token = response.headers["access-token"];
  if (token) {
    userService.setToken(token)
  }
  return response;
}, (error) => {
  // 对响应错误做点什么
  if (error.response.status === 401) {
    console.log("Received 401 Response")
    // router.push('/login');
  }
  return Promise.reject(error);
});
export default myselfAxios;
